export default "__VITE_ASSET__CqfJBybk__"